import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

import { DEFAULT_HEIGH, DEFAULT_WIDTH } from "./static-map.constants";

/**
 * The pin's colour used to be painted from here, because the Leaflet marker was HTML whose fill came from
 * CSS. The MapLibre pin is an SVG that takes its colour as a prop, so those rules — and the clip-path that
 * gave the HTML pin its teardrop shape — are gone with it.
 */
export const StaticMapContainerStyled = styled.div.attrs<IStyledAttributes>(
  props => ({
    [DATA_E2E_KEY]: props[DATA_E2E_KEY] ?? "static-map-container",
  }),
)`
  border: 1px solid ${rydeColors.lightGreyBorder};
  border-radius: 4px;
  width: ${DEFAULT_WIDTH}px;
  height: ${DEFAULT_HEIGH}px;
`;
